import Cookies from "js-cookie";
import { decryptData } from "utils/crypto";




export const announcementSteps =()=>{
const roleId = Number(decryptData(Cookies.get("role_id")));

 return[
  {
    target: '[data-tour="announcements-module"]',
    title: '📢 Welcome to Announcements',
    content:
      'Here you can view company updates, important messages, and internal communications.',
    disableBeacon: true,
  },

  ...(roleId === 2
    ? [
        {
          target: '[data-tour="create-announcement-btn"]',
          title: '➕ Create Announcement',
          content:
            'Admins can create new announcements and broadcast updates to employees.',
          disableBeacon: true,
        },
      ]
    : []),
];
}